//export const API_url = 'http://localhost:3667';

export const API_url = 'https://cheapi.s-vfu.ru';